import { CztWidgets } from '~/utils/views/widgets';
import { SearchFormInterface } from './types';

export default function(data: any): data is SearchFormInterface {
  return data && data.className === CztWidgets.SEARCH;
}
